import React, { useEffect, useRef, useState } from 'react';
import { Icon } from 'assets/Icon';
import './CTA.scss';

const CTA: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section className="cta-section">
      <div className={`cta-content ${isVisible ? 'visible' : ''}`} ref={sectionRef}>
        <div className="cta-logo">
          <Icon name="logo3" className="cta-logo" />
        </div>
        <div className="cta-text">
          <h2>Stay Ahead of Every Filing, Ruling, and Schedule Change.</h2>
          <p>
            SGT Docket Rocket delivers real-time Connecticut judicial updates. 
            Faster, smarter, and more detailed than ever before.
          </p>
        </div>
        <a href="https://apps.apple.com/us/app/sgt-docket-rocket/id6499451413" className="app-store-badge">
          <Icon name="app-store" className="cta-appstore" />
        </a>
      </div>
    </section>
  );
};

export default CTA;

